export const validationStandardMessages = Object.freeze({
  isRequired: 'This field cannot be empty',
  atLeastOneFileRequired: 'At least one file is required',
  atLeastOneFileTypeRequired: 'At least one file type is required',
  invalidEmailFormat: 'Invalid email format',
});
